<div class="content-wrapper">
  <div class="page-title-box">
    <h4>Purchase Place</h4>
  </div>

  <div class="card card-nobody">
    <div class="card-body">

      <div class="row mb-0">
        <div class="col-lg-8 col-sm-8">
          <div class="row search-box">
            <div class="col-lg-5 mb-2">
              <div class="position-relative">
                <input [formControl]="searchText"
                       class="form-control border-light rounded"
                       placeholder="Search..."
                       type="search">
                <i class="uil uil-search search-icon"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-sm-4">
          <div *ngIf="!isAdminViewerRole" class="mt-4 mt-sm-0 d-flex align-items-center justify-content-sm-end">
            <button (click)="openPurchasePlaceEdit()" class="btn btn-dark" type="button">
              <font-awesome style="color:white">New</font-awesome>
            </button>
          </div>
        </div>
      </div>

      <div class="table-wrapper">

        <app-dp-list (pageEvent)="onPageEvent($event)"
                     [pagedResponse]="pagedResponse"
                     [selectedItem]="selectedData"
        >
          <table
            [ngClass]="{
              'table': true,
              'table-list' : true,
              'align-middle': true,
              'table-nowrap': true,
              'table-check': true,
              'w-100': true
              }">
            <thead>
            <tr>
              <th>No.</th>
              <th [attr.data-sort-fields]="'code'">Code</th>
              <th [attr.data-sort-fields]="'name'">Name</th>
              <th [attr.data-sort-fields]="'displayOrder'">Display Order</th>
              <th></th>
            </tr>
            </thead>

            <tbody>
            <tr *ngFor="let purchasePlace of purchasePlaces; let i = index">
              <ng-container>
                <td>{{ i + 1 }}</td>
                <td>{{ purchasePlace.code }}</td>
                <td>{{ purchasePlace.name }}</td>
                <td>{{ purchasePlace.displayOrder }}</td>
                <td>
                  <div *ngIf="!isAdminViewerRole" class="edit-button-container">
                    <button (click)="deletePurchasePlace(purchasePlace.code)" class="btn btn-light button-small wd-48px"
                            style="border-color: black" type="button">
                      <font-awesome style="color:black;">Delete</font-awesome>
                    </button>
                    <div style="width: 10px;"></div>
                    <button (click)="openPurchasePlaceEdit(purchasePlace)" class="btn btn-dark button-small wd-48px"
                            type="button">
                      <font-awesome style="color:white">Edit</font-awesome>
                    </button>
                  </div>
                </td>
              </ng-container>
            </tr>
            </tbody>

          </table>
        </app-dp-list>
      </div>
    </div>
  </div>
</div>
